module.exports = __webpack_public_path__ + "static/img/pamphlet.853cb7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hakodate/pamphlet.svg
// module id = gnzf
// module chunks = 0